import { createFileRoute } from "@tanstack/react-router";
import { CyclesPage } from "@/features/cycles/CyclesPage";

export const Route = createFileRoute("/_app/cycles/")({ component: CyclesPage });
